import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Massachusetts = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Massachusetts Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Disclosure of known defects required; no specific form mandated.
        </Text>

        <Text style={styles.listItem}>
          2. Mandatory Disclosures: Lead paint, septic system (Title V), and
          others as required.
        </Text>

        <Text style={styles.listItem}>
          3. Purchase and Sale Agreement: Often reviewed by attorneys.
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          5. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          While not required by Massachusetts state law, sellers may choose to
          provide buyers with a property condition report.
        </Text>

        <Text style={styles.listItem}>
          6.{' '}
          <Text style={styles.underline}>Title 5 Addendum (Septic Tanks)</Text>{' '}
          – Sellers must disclose the presence of septic tanks to buyers.
        </Text>
      </View>
    </View>
  );
};

export default Massachusetts;
